import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const SoutheastMap = ({ onStateClick }) => {
	const [selectedState, setSelectedState] = useState(null);
	const [isVisible, setIsVisible] = useState(true);

	const handleStateClick = (area) => {
		setSelectedState(area);
		setIsVisible(false);
		setTimeout(() => {
			onStateClick(area);
		}, 500);
		console.log('State Clicked: %s', area);
	};

	return (
		<svg
			id='southeast-region'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 2800 2600'
			className={`map ${!isVisible ? 'hidden' : ''}`}>
			<polygon
				id='LA'
				points='849.5 1876 823.5 1876 787.5 1860 772.31 1850 746.5 1850 730.5 1857 716.5 1871 719.04 1888 731.5 1899 752.5 1903 772.5 1899 783.5 1893 800.5 1888 811.5 1897 802.5 1911 809.5 1919 826.5 1923 836.5 1915 846.5 1903 858.5 1908 865.5 1923 862.5 1938 848.5 1942 845.5 1960 829.28 1962 829.5 1979 850.5 1992 874.5 2002 905.5 2016 919.5 2034 912.5 2050 898.5 2053 878.5 2044 836.5 2020 811.5 2005 783.5 1992 761.5 1982 773.5 2001 779.5 2015 773.5 2028.64 773.5 2048 760.5 2059 751.5 2054 746.5 2037 734.5 2034 722.5 2023 704.5 2040 682.5 2059 666.5 2059 654.5 2052 632.5 2040 608.5 2015 582.5 2000 560.5 1986 517.54 1962 495.5 1962 485.89 1970 483.5 1998 445.5 1999 414.5 1997 351.5 1980 324.49 1970 291.5 1970 263.5 1982 228.5 1988 242.5 1949 255.5 1923 253.5 1838 268.5 1801 273.5 1774 264.5 1737 241.5 1682 219.5 1636 198.5 1614 198.5 1450 584.5 1437 588.5 1481 611.5 1520 613.5 1553 612.5 1581 596.5 1609 565.5 1654 547.5 1707 539.5 1763 802.5 1745 804.5 1758 793.5 1782 790.5 1802 806.5 1827 822.5 1846 849.5 1876'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='LA'
				className={`polygon ${selectedState === 'LA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('LA')}
			/>
			<polygon
				id='MS'
				points='849.5 1876 822.5 1846 806.5 1827 790.5 1802 793.5 1782 804.5 1758 802.5 1745 539.5 1763 547.5 1707 565.5 1654 596.5 1609 612.5 1581 613.5 1553 611.5 1520 588.5 1481 584.5 1437 588.5 1392 586.5 1369 576.5 1341 578.5 1314 602.5 1273 610.5 1242 642.5 1198 654.5 1162 661.5 1134 680.5 1104 967.5 1078 961.5 1597 989.5 1809 1000.5 1831 986.5 1837 965.5 1838 933.5 1835 897.5 1838 869.37 1850 849.5 1876'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='MS'
				className={`polygon ${selectedState === 'MS' ? 'selected' : ''}`}
				onClick={() => handleStateClick('MS')}
			/>
			<polygon
				id='AL'
				points='1000.5 1831 1035.52 1831 1035.52 1791.81 1042.5 1775 1051.5 1779 1056.5 1789 1056.5 1810.27 1079.5 1827 1094.5 1846 1110.5 1835 1122.5 1817 1130.5 1804 1129.65 1778.47 1097.21 1748 1097.5 1732 1113.5 1718 1453.5 1684 1438.5 1627 1420.5 1544 1421.5 1527 1439.5 1475 1414.5 1425 1389.5 1380 1352.5 1252 1293.5 1044 967.5 1078 961.5 1597 989.5 1809 1000.5 1831'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='AL'
				className={`polygon ${selectedState === 'AL' ? 'selected' : ''}`}
				onClick={() => handleStateClick('AL')}
			/>
			<polygon
				id='FL'
				points='1453.5 1684 1113.5 1718 1097.5 1732 1097.21 1748 1129.65 1778.47 1130.5 1804 1136.5 1807 1140.5 1828 1209.5 1806 1265.5 1803 1320.5 1805 1357.5 1818 1382.5 1833 1415.5 1857 1442.5 1891 1462.5 1889 1494.5 1879 1524.5 1863 1545.5 1850 1560.5 1847 1563.5 1827 1577.5 1812 1624.5 1812 1650.5 1826 1670.5 1845 1694.5 1867 1728.5 1905 1756.5 1926 1790.5 1942 1810.5 1955 1830.5 1979 1836.5 2007 1836.5 2068 1830.5 2098 1823.5 2121 1823.5 2150 1834.5 2159 1846.5 2166 1857.5 2158 1860.5 2142 1868.5 2131 1881.5 2130 1890.5 2138 1882.5 2155 1870.5 2179 1860.5 2193 1861.5 2208 1899.5 2265 1919.5 2285 1927.5 2289 1939.5 2284 1946.5 2275 1957.5 2285 1960.5 2300 1960.5 2315.95 1971.5 2330 1989.5 2349 2006.5 2365 2006.5 2385.57 2019.5 2402 2033.5 2420 2042.5 2426 2069.5 2426 2087.5 2440 2114.5 2474 2132.5 2505 2135.5 2528 2143.5 2537 2179.5 2537 2204.5 2531 2227.5 2514 2246.5 2489 2246.5 2445.7 2249.5 2431 2260.5 2409 2265.5 2381 2262.5 2343 2258.5 2306 2257.5 2272 2242.5 2227 2221.5 2190 2195.5 2150 2164.5 2098 2126.5 2043 2105.5 2003 2091.5 1966 2113.5 1969 2110.5 1955 2070.5 1912 2036.5 1865 2005.5 1812 1981.5 1765 1961.5 1716 1938.5 1666 1938.5 1655.52 1875.43 1655.52 1867.5 1670 1874.5 1703 1871.5 1721 1859.5 1725 1842.5 1698 1778.5 1701 1479.5 1724 1453.5 1684'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='FL'
				className={`polygon ${selectedState === 'FL' ? 'selected' : ''}`}
				onClick={() => handleStateClick('FL')}
			/>
			<polygon
				id='GA'
				points='1453.5 1684 1479.5 1724 1778.5 1701 1842.5 1698 1859.5 1725 1871.5 1721 1874.5 1703 1867.5 1670 1875.43 1655.52 1938.5 1655.52 1938.5 1588 1953.5 1551 1962.5 1502 1975.5 1464 1991.5 1436 1967.5 1426 1944.5 1401 1939.5 1378 1907.5 1349 1896.5 1315 1868.5 1286 1850.5 1276 1807.5 1228 1770.5 1193 1732.5 1169 1714.5 1155 1680.5 1119 1669.52 1097.04 1657.5 1086 1633.5 1084 1611.5 1072 1598.5 1052 1599.5 1033 1615.5 1011 1615.5 1002 1588.5 1004 1460.5 1024 1293.5 1044 1352.5 1252 1389.5 1380 1414.5 1425 1439.5 1475 1421.5 1527 1420.5 1544 1438.5 1627 1453.5 1684'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='GA'
				className={`polygon ${selectedState === 'GA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('GA')}
			/>
			<polygon
				id='SC'
				points='1991.5 1436 1997.5 1416 2010.5 1403 2011.5 1391 2025.5 1389 2038.5 1376 2034.5 1363 2027.5 1354 2046.5 1346 2081.5 1321 2120.5 1284 2155.5 1241 2177.5 1206 2186.5 1161 2204.5 1126 2224.5 1102 2243.5 1083 2074.5 962 1945.5 983 1927.5 983 1921.5 964 1895.5 942 1807.82 942 1733.5 949 1700.5 960 1665.5 983 1640.5 990 1615.5 1002 1615.5 1011 1599.5 1033 1598.5 1052 1611.5 1072 1633.5 1084 1657.5 1086 1669.52 1097.04 1680.5 1119 1714.5 1155 1732.5 1169 1770.5 1193 1807.5 1228 1850.5 1276 1868.5 1286 1896.5 1315 1907.5 1349 1939.5 1378 1944.5 1401 1967.5 1426 1991.5 1436'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='SC'
				className={`polygon ${selectedState === 'SC' ? 'selected' : ''}`}
				onClick={() => handleStateClick('SC')}
			/>
			<polygon
				id='NC'
				points='2243.5 1083 2270.5 1072 2304.5 1063 2321.5 1052 2328.5 1031 2328.5 1006.1 2342.5 980 2368.5 952 2400.5 925 2431.5 906 2462.5 894 2491.5 876 2498.5 859 2498.5 838.76 2483.5 837 2470.5 848 2455.5 857 2455.5 849 2461.5 832 2465.5 811 2459.5 801 2459.5 784 2498.5 784 2525.5 766 2539.5 742 2544.5 727 2544.5 696.74 2528.5 682 2480.5 682 2457.5 696 2431.5 694 2426.5 684 2447.65 679 2461.5 666 2493.5 649 2516.49 649 2509.5 624 2482.5 593 2478.66 585.06 2290.5 627 1979.5 684 1763.5 719 1754.5 758 1734.5 785 1683.5 819 1663.5 833 1640.15 833 1618.5 860 1592.5 884 1553.5 914 1510.5 929 1494.5 945 1487.5 963 1463.5 992 1460.5 1024 1615.5 1002 1640.5 990 1665.5 983 1700.5 960 1733.5 949 1807.82 942 1895.5 942 1921.5 964 1927.5 983 1945.5 983 2074.5 962 2243.5 1083'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='NC'
				className={`polygon ${selectedState === 'NC' ? 'selected' : ''}`}
				onClick={() => handleStateClick('NC')}
			/>
			<g
				id='VA'
				data-area='VA'
				className={`polygon ${selectedState === 'VA' ? 'selected' : ''}`}
				onClick={() => handleStateClick('VA')}>
				<polygon
					points='2478.66 585.06 2467.5 562 2438.5 527 2419.5 499 2406.5 477 2421.5 465 2421.5 447 2402.5 428 2403.5 400 2399.5 376 2374.5 369 2352.5 353 2315.5 347 2294.5 331 2279.52 331 2262.5 342 2249.5 325 2255.5 297 2268.5 282 2280.5 264 2279.64 248.54 2266.5 235 2238.1 224 2217.53 220.57 2212.79 203 2197.36 187.47 2171.5 187.47 2171.5 207.41 2163.34 214.46 2148.7 210 2112.7 187.47 2097.5 190 2090.15 203 2080.5 264 2027.43 323.71 2009.5 364 1990.5 364 1969.5 355 1958.5 366 1946.5 408 1914.5 489 1914.5 537.57 1890.5 557 1861.21 567.41 1821.53 585.06 1793.5 595 1743.6 595 1698.5 576 1680.5 601 1639.5 634 1617.5 661 1606.5 686 1576.5 715 1537.5 742 1547.5 747 1763.5 719 1979.5 684 2290.5 627 2478.66 585.06'
					fill='#ccc'
					stroke='#fff'
					strokeMiterlimit='10'
					strokeWidth='10'
					data-area='VA'
					className={`polygon ${selectedState === 'VA' ? 'selected' : ''}`}
					onClick={() => handleStateClick('VA')}
				/>
				<polygon
					points='2465.5 494 2462.5 485 2462.5 439 2468.5 409 2469.5 359 2505.5 352 2496.5 406 2484.5 451 2465.5 494'
					fill='#ccc'
					stroke='#fff'
					strokeMiterlimit='10'
					strokeWidth='10'
					data-area='VA'
					className={`polygon ${selectedState === 'VA' ? 'selected' : ''}`}
					onClick={() => handleStateClick('VA')}
				/>
			</g>
			<polygon
				id='MD'
				points='2505.5 352 2516.5 325 2525.5 283 2527.5 255 2455.5 278 2397.5 79 2366.5 84 2296.5 101 2117.5 137 1952.33 168 1963.5 245 1994.81 214.46 2043.5 170 2059.5 175 2077.62 172.67 2098.5 152 2133.5 145 2157.5 161 2171.5 187.47 2197.36 187.47 2212.79 203 2217.53 220.57 2238.1 224 2266.5 235 2279.64 248.54 2280.5 264 2268.5 282 2269.5 314 2328.5 321 2351.5 331 2383.5 346 2379.5 326 2367.5 304 2351.5 279 2336.5 245 2332.5 222 2332.5 183 2345.5 158 2359.5 137 2368.5 125 2375.5 129 2374.5 161 2369.5 178 2367.5 224 2380.5 260 2387.5 274 2387.5 302 2417.5 304 2437.5 312 2451.5 323 2455.5 336 2455.5 358 2469.5 359 2505.5 352'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='MD'
				className={`polygon ${selectedState === 'MD' ? 'selected' : ''}`}
				onClick={() => handleStateClick('MD')}
			/>
			<polygon
				id='DE'
				points='2527.5 255 2521.5 224 2512.5 205 2487.5 192 2470.5 167 2459.5 142 2443.5 112 2431.5 92 2430.5 75 2437.5 60 2430.5 45 2405.5 56 2397.5 79 2455.5 278 2527.5 255'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='DE'
				className={`polygon ${selectedState === 'DE' ? 'selected' : ''}`}
				onClick={() => handleStateClick('DE')}
			/>
			<polygon
				id='WV'
				points='2171.5 187.47 2157.5 161 2133.5 145 2098.5 152 2077.62 172.67 2059.5 175 2043.5 170 1994.81 214.46 1963.5 245 1952.33 168 1824.5 192 1799.64 45 1789.5 49 1788.5 112 1783.5 180 1770.5 218 1753.5 250 1720.5 262 1706.5 281 1677.5 325 1655.5 350 1644.5 381 1643.5 410 1627.5 436 1607.5 443 1607.5 480.18 1627.5 513 1668.5 553 1698.5 576 1743.6 595 1793.5 595 1821.53 585.06 1861.21 567.41 1890.5 557 1914.5 537.57 1914.5 489 1946.5 408 1958.5 366 1969.5 355 1990.5 364 2009.5 364 2027.43 323.71 2080.5 264 2090.15 203 2097.5 190 2112.7 187.47 2148.7 210 2163.34 214.46 2171.5 207.41 2171.5 187.47'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='WV'
				className={`polygon ${selectedState === 'WV' ? 'selected' : ''}`}
				onClick={() => handleStateClick('WV')}
			/>
			<polygon
				id='KY'
				points='1547.5 747 1537.5 742 1576.5 715 1606.5 686 1617.5 661 1639.5 634 1680.5 601 1698.5 576 1668.5 553 1627.5 513 1607.5 480.18 1607.5 443 1568.5 411 1546.5 400 1523.5 413 1408.5 413 1376.5 381 1350.5 364 1313.5 364 1303.5 374 1307.5 387 1315.5 404 1308.5 421 1295.5 434 1271.5 441 1248.5 439 1237.5 478 1197.5 533 1193.19 554 1179.5 570 1165.5 566 1153.5 559 1141.5 549 1129.9 554 1114.5 589 1102.5 592 1082.5 586 1068.5 589 1055.5 606 1034.5 606 1016.5 597 985.5 606 936.5 624 932.5 637 929.5 662 922.5 678 904.5 686 882.5 708 894.5 729 890.5 745 868.5 750 847.5 733 824.75 724.5 806.5 738 803.5 761 808.5 794 802.5 827 778.5 834 795.99 847 947.5 837 953.5 811 1156.5 795 1547.5 747'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='KY'
				className={`polygon ${selectedState === 'KY' ? 'selected' : ''}`}
				onClick={() => handleStateClick('KY')}
			/>
			<polygon
				id='TN'
				points='1460.5 1024 1463.5 992 1487.5 963 1494.5 945 1510.5 929 1553.5 914 1592.5 884 1618.5 860 1640.15 833 1663.5 833 1683.5 819 1734.5 785 1754.5 758 1763.5 719 1547.5 747 1156.5 795 953.5 811 947.5 837 795.99 847 778.5 834 761.5 863 757.5 894 739.5 940 731.5 970 705.5 1033 702.5 1064 679.5 1091 680.5 1104 967.5 1078 1293.5 1044 1460.5 1024'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='TN'
				className={`polygon ${selectedState === 'TN' ? 'selected' : ''}`}
				onClick={() => handleStateClick('TN')}
			/>
			<polygon
				id='AR'
				points='198.5 1450 584.5 1437 588.5 1392 586.5 1369 576.5 1341 578.5 1314 602.5 1273 610.5 1242 642.5 1198 654.5 1162 661.5 1134 680.5 1104 679.5 1091 702.5 1064 705.5 1033 731.5 970 739.5 940 690.5 939 669.5 943 665.5 933 674.5 918 689.5 903 691.5 876 676.5 862 589.5 866 412.5 878 194.5 885.24 105.5 885.24 105.5 906 111.5 938 125.5 989 134.5 1070 134.5 1350 141.5 1359 158.5 1363 192.5 1364 198.5 1450'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='10'
				data-area='AR'
				className={`polygon ${selectedState === 'AR' ? 'selected' : ''}`}
				onClick={() => handleStateClick('AR')}
			/>
			<rect x='2069.5' y='210' width='233.07' height='43' fill='none' className='shape' />
			<path
				d='M2139.85,236.6l-3.86,7.67h-3.14l12.53-24.26h3.53l3.35,24.26h-3.06l-.98-7.67h-8.37ZM2148,234.23l-.94-7.01c-.13-1.26-.31-3.04-.43-4.46h-.08c-.65,1.45-1.25,2.96-1.99,4.42l-3.62,7.05h7.06Z'
				className='shape'
			/>
			<path
				d='M2158.41,244.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M2180.51,244.28l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M2214.16,244.28c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM2216.09,229.1c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M2222.79,251.41l3.49-18.36c.39-2.09.75-4.42.98-6.17h2.73l-.49,3.28h.07c1.58-2.3,3.88-3.67,6.26-3.67,3.77,0,5.36,3.1,5.36,6.29,0,6.13-4.4,11.91-10.2,11.91-1.85,0-3.08-.41-3.75-.78h-.07l-1.41,7.51h-2.97ZM2227.69,241.36c.77.6,1.9.96,3.32.96,3.85,0,7.07-4.78,7.07-9.33,0-1.83-.81-4.03-3.34-4.03-2.35,0-5.27,2.67-6.17,7.54l-.88,4.86Z'
				className='shape'
			/>
			<path
				d='M2262.95,233.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM2249.56,237.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path d='M2267.92,244.28l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M2279.04,244.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2282.92,222.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2290.31,241.26c.82.49,2.31,1.09,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.61,0,1.28.84,2.06,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<polygon
				points='2311.81 177.08 2312.18 192 2327.88 192 2312.41 201.22 2312.78 216.15 2302.86 206.92 2287.39 216.15 2296.72 201.22 2286.8 192 2302.49 192 2311.81 177.08'
				className='shape'
			/>
			<rect x='2477.57' y='182' width='132.93' height='42' fill='none' className='shape' />
			<path
				d='M2483.25,191.84c1.86-.32,3.91-.49,6.03-.49,4.05,0,7.13,1.15,8.93,3.23,1.31,1.35,2.27,3.52,2.28,6.58,0,4.39-1.75,8.74-4.87,11.4-2.81,2.36-6.34,3.38-11,3.38-2.12,0-4.31-.12-5.89-.3l4.52-23.79ZM2482.16,213.3c1.09.14,2.23.17,3.13.17,3.85,0,6.66-1.13,8.68-3.22,2.18-2.23,3.31-5.54,3.31-8.95,0-4.29-2.1-7.51-8.15-7.51-1.08,0-2.44.07-3.31.25l-3.66,19.25Z'
				className='shape'
			/>
			<path
				d='M2521.86,205.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM2508.48,208.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M2530.45,198.37l1.5,9.91c.26,1.98.49,3.32.56,4.28h.1c.38-.92.85-2.07,1.86-4.06l5.31-10.13h3.27l-9.69,17.41h-2.94l-3.01-17.41h3.04Z'
				className='shape'
			/>
			<path
				d='M2558.1,214.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM2554.8,200.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M2564.74,215.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.18l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<polygon
				points='2467.33 151.31 2467.69 166 2483.14 166 2467.92 175.08 2468.28 189.77 2458.51 180.69 2443.28 189.77 2452.47 175.08 2442.69 166 2458.14 166 2467.33 151.31'
				className='shape'
			/>
			<rect x='1341.92' y='545' width='210.58' height='38' fill='none' className='shape' />
			<path
				d='M1347.66,552.52h12.31l-.5,2.55h-9.31l-1.57,8.18h8.58l-.5,2.54h-8.58l-2.08,10.99h-2.98l4.61-24.26Z'
				className='shape'
			/>
			<path
				d='M1361.81,576.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.18l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1387.14,576.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1389.07,561.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1397.34,576.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1419.45,576.78l4.86-25.56h2.97l-3.06,16.02h.07c.53-.61,1.17-1.27,1.63-1.75l6.13-6.12h3.69l-7.6,7.15,5.2,10.26h-3.29l-4.19-8.59-2.2,1.97-1.25,6.63h-2.96Z'
				className='shape'
			/>
			<path
				d='M1439.15,576.78l2.86-15.06h-2.32l.45-2.34h2.33l.17-.93c.43-2.42,1.29-4.66,2.85-6.07,1.1-.99,2.62-1.54,4.13-1.54,1.2,0,1.98.23,2.39.47l-.65,2.39c-.46-.22-1.07-.34-1.75-.34-2.37,0-3.53,2.32-4.04,5.19l-.15.83h3.88l-.46,2.34h-3.87l-2.86,15.06h-2.96Z'
				className='shape'
			/>
			<path
				d='M1468.44,566.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1455.05,569.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1473.4,576.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.18l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1496.46,554.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<polygon
				points='1331.17 515.08 1331.54 530 1347.23 530 1331.76 539.22 1332.13 554.15 1322.21 544.92 1306.75 554.15 1316.07 539.22 1306.15 530 1321.84 530 1331.17 515.08'
				className='shape'
			/>
			<rect x='1737.92' y='381' width='246.58' height='38' fill='none' className='shape' />
			<path
				d='M1755.81,412c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.98-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M1761.8,412.78l4.86-25.56h2.98l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<path
				d='M1795.45,412.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1797.38,397.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1805.65,412.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.18l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path d='M1819.95,412.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M1843.62,411.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1840.32,397.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1850.4,409.76c.82.49,2.31,1.09,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.61,0,1.28.84,2.06,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1874.35,390.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M1897.27,402.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1883.88,405.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1902.23,412.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<polygon
				points='1728.17 419.08 1728.54 434 1744.23 434 1728.76 443.22 1729.13 458.15 1719.21 448.92 1703.75 458.15 1713.07 443.22 1703.15 434 1718.84 434 1728.17 419.08'
				className='shape'
			/>
			<rect x='2025.92' y='499' width='227.58' height='42' fill='none' className='shape' />
			<path
				d='M2091.17,508.88c1.48-.33,3.49-.52,5.29-.52,2.42,0,4.5.57,5.8,1.76,1.12.97,1.79,2.36,1.79,4.02,0,3.52-2.7,6.16-5.76,7.01v.09c1.69.56,2.49,2.38,2.67,4.87.27,3.38.44,5.7.76,6.67h-3.09c-.14-.51-.39-3.05-.56-5.85-.19-3.34-1.42-4.72-3.82-4.72h-2.65l-2,10.57h-2.96l4.55-23.9ZM2092.04,519.89h2.67c3.78,0,6.22-2.47,6.22-5.38,0-2.6-1.96-3.76-4.69-3.76-1.19,0-1.96.1-2.51.26l-1.69,8.88Z'
				className='shape'
			/>
			<path
				d='M2108.54,532.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2112.42,510.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2131.64,532.09c-.89.44-2.69,1.07-5.06,1.07-4.48,0-6.7-3.04-6.7-6.73,0-5.94,4.42-11.44,10.68-11.44,1.62,0,3.09.47,3.62.79l-.85,2.37c-.69-.33-1.65-.66-2.96-.66-4.52,0-7.38,4.46-7.38,8.56,0,2.83,1.48,4.66,4.34,4.66,1.77,0,3.13-.54,4.02-.97l.29,2.36Z'
				className='shape'
			/>
			<path
				d='M2137.77,532.78l4.86-25.56h2.98l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<path
				d='M2159.88,532.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.81-.11,1.98-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.5-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M2208.55,522.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM2195.16,525.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M2213.52,532.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M2254.14,507.22l-3.82,20.04c-.34,1.8-.63,3.83-.73,5.52h-2.73l.46-3.44h-.07c-1.59,2.47-3.78,3.84-6.28,3.84-3.36,0-5.2-2.76-5.2-6.34,0-6.19,4.6-11.86,10.77-11.86,1.09,0,2.32.23,3.07.6l1.56-8.35h2.97ZM2249.13,518.1c-.6-.41-1.6-.74-2.85-.74-4.18,0-7.42,4.45-7.42,9.07,0,2.11.72,4.29,3.28,4.29,2.29,0,5.08-2.62,5.82-6.54l1.17-6.09Z'
				className='shape'
			/>
			<polygon
				points='2275.17 457.08 2275.54 472 2291.23 472 2275.76 481.22 2276.13 496.15 2266.21 486.92 2250.75 496.15 2260.07 481.22 2250.15 472 2265.84 472 2275.17 457.08'
				className='shape'
			/>
			<rect x='1993.5' y='724' width='168' height='50' fill='none' className='shape' />
			<path
				d='M2041.54,737.88c1.48-.33,3.49-.52,5.29-.52,2.42,0,4.5.57,5.8,1.76,1.12.97,1.79,2.36,1.79,4.02,0,3.52-2.7,6.16-5.76,7.01v.09c1.69.56,2.49,2.38,2.67,4.87.27,3.38.44,5.7.76,6.67h-3.09c-.14-.51-.39-3.05-.56-5.85-.19-3.34-1.42-4.72-3.82-4.72h-2.65l-2,10.57h-2.96l4.55-23.9ZM2042.41,748.89h2.67c3.78,0,6.22-2.47,6.22-5.38,0-2.6-1.96-3.76-4.69-3.76-1.19,0-1.96.1-2.51.26l-1.69,8.88Z'
				className='shape'
			/>
			<path
				d='M2069.99,761.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM2071.93,746.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path d='M2080.13,761.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M2103.8,760.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM2100.5,746.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M2110.43,761.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM2114.31,739.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M2121.71,765.73c1.06.67,2.79,1.14,4.62,1.14,2.93,0,5.23-1.49,6.26-6.2l.58-2.6h-.09c-1.52,2.49-3.65,3.7-6.05,3.7-3.5,0-5.3-2.94-5.3-6.03-.01-5.93,4.31-11.76,11.05-11.76,2.02,0,4.22.56,5.59,1.21l-2.67,14.39c-.7,3.69-1.7,6.23-3.51,7.79-1.74,1.51-4.09,1.93-6.08,1.93-2.12,0-4.13-.49-5.22-1.23l.83-2.34ZM2135.09,746.96c-.55-.27-1.63-.59-2.88-.59-4.36,0-7.36,4.56-7.38,8.85-.01,1.93.68,4.17,3.34,4.17s5.16-3.24,5.81-6.63l1.11-5.8Z'
				className='shape'
			/>
			<path
				d='M2143.3,761.78l4.86-25.56h2.99l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<polygon
				points='2181.17 771.08 2181.54 786 2197.23 786 2181.76 795.22 2182.13 810.15 2172.21 800.92 2156.75 810.15 2166.07 795.22 2156.15 786 2171.84 786 2181.17 771.08'
				className='shape'
			/>
			<rect x='617.59' y='1771' width='289.91' height='46' fill='none' className='shape' />
			<path
				d='M623.25,1782.86c1.48-.3,3.23-.5,5.2-.5,2.5,0,4.31.5,5.6,1.66,1.12.91,1.74,2.2,1.74,3.78,0,3.07-2.47,5.34-5.22,6.05v.1c2.19.64,4,2.46,3.98,5.38,0,2.48-1.32,4.44-2.9,5.62-1.93,1.44-4.6,1.99-7.85,1.99-2.08,0-3.89-.13-5.03-.34l4.49-23.74ZM622.1,1804.37c.76.12,1.64.16,2.45.16,3.53.02,6.85-1.46,6.85-5.34,0-2.85-2.4-4.1-5.12-4.1h-2.43l-1.75,9.28ZM624.33,1792.81h2.22c3.48,0,6.16-1.8,6.16-4.75,0-2.34-1.76-3.33-4.4-3.33-1.1,0-2.01.08-2.48.22l-1.5,7.86Z'
				className='shape'
			/>
			<path
				d='M651.79,1806.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM653.73,1791.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M669.75,1784.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M692.66,1796.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM679.28,1799.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M697.63,1806.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M733.83,1782.88c1.48-.33,3.49-.52,5.29-.52,2.42,0,4.5.57,5.8,1.76,1.12.97,1.79,2.36,1.79,4.02,0,3.52-2.7,6.16-5.76,7.01v.09c1.69.56,2.49,2.38,2.67,4.87.27,3.38.44,5.7.76,6.67h-3.09c-.14-.51-.39-3.05-.56-5.85-.19-3.34-1.42-4.72-3.82-4.72h-2.65l-2,10.57h-2.96l4.55-23.9ZM734.7,1793.89h2.67c3.78,0,6.22-2.47,6.22-5.38,0-2.6-1.96-3.76-4.69-3.76-1.19,0-1.96.1-2.51.26l-1.69,8.88Z'
				className='shape'
			/>
			<path
				d='M767.51,1796.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM754.12,1799.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M789.45,1789.37l-2.35,12.34c-.37,1.94-.61,3.62-.78,5.07h-2.69l.45-3.29h-.07c-1.55,2.27-3.84,3.68-6.14,3.68s-4.6-1.08-4.6-5.04c0-.84.11-1.78.33-2.93l1.88-9.83h2.98l-1.85,9.7c-.19.97-.3,1.8-.3,2.55,0,1.8.74,3.03,2.78,3.03,2.18,0,4.95-2.54,5.67-6.36l1.7-8.93h2.98Z'
				className='shape'
			/>
			<path
				d='M794.3,1810.73c1.06.67,2.79,1.14,4.62,1.14,2.93,0,5.23-1.49,6.26-6.2l.58-2.6h-.09c-1.52,2.49-3.65,3.7-6.05,3.7-3.5,0-5.3-2.94-5.3-6.03-.01-5.93,4.31-11.76,11.05-11.76,2.02,0,4.22.56,5.59,1.21l-2.67,14.39c-.7,3.69-1.7,6.23-3.51,7.79-1.74,1.51-4.09,1.93-6.08,1.93-2.12,0-4.13-.49-5.22-1.23l.83-2.34ZM807.68,1791.96c-.55-.27-1.63-.59-2.88-.59-4.36,0-7.36,4.56-7.38,8.85-.01,1.93.68,4.17,3.34,4.17s5.16-3.24,5.81-6.63l1.11-5.8Z'
				className='shape'
			/>
			<path
				d='M828.44,1805.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM825.14,1791.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='600.84 1813.08 601.21 1828 616.9 1828 601.44 1837.22 601.81 1852.15 591.88 1842.92 576.42 1852.15 585.74 1837.22 575.82 1828 591.51 1828 600.84 1813.08'
				className='shape'
			/>
			<rect x='541.5' y='1541' width='178' height='38' fill='none' className='shape' />
			<path
				d='M586.7,1570c.79.34,1.77.53,3.05.53,2.54,0,4.16-1.34,4.97-5.64l3.1-16.37h2.98l-3.17,16.69c-1.07,5.68-3.44,7.96-7.98,7.96-1.47,0-2.99-.31-3.6-.63l.65-2.55Z'
				className='shape'
			/>
			<path
				d='M615.79,1572.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM617.72,1557.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M637.89,1572.09c-.89.44-2.69,1.07-5.06,1.07-4.48,0-6.7-3.04-6.7-6.73,0-5.94,4.42-11.44,10.68-11.44,1.62,0,3.09.47,3.62.79l-.85,2.37c-.69-.33-1.65-.66-2.96-.66-4.52,0-7.38,4.46-7.38,8.56,0,2.83,1.48,4.66,4.34,4.66,1.77,0,3.13-.54,4.02-.97l.29,2.36Z'
				className='shape'
			/>
			<path
				d='M644.03,1572.78l4.86-25.56h2.97l-3.06,16.02h.07c.53-.61,1.17-1.27,1.63-1.75l6.13-6.12h3.69l-7.6,7.15,5.2,10.26h-3.29l-4.19-8.59-2.2,1.97-1.25,6.63h-2.96Z'
				className='shape'
			/>
			<path
				d='M663.46,1569.76c.82.49,2.31,1.09,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.61,0,1.28.84,2.06,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M696.33,1562.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM682.94,1565.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M701.3,1572.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<polygon
				points='747.8 1519.08 748.17 1534 763.86 1534 748.4 1543.22 748.77 1558.15 738.85 1548.92 723.38 1558.15 732.71 1543.22 722.79 1534 738.48 1534 747.8 1519.08'
				className='shape'
			/>
			<rect x='1256.56' y='1486' width='291.94' height='38' fill='none' className='shape' />
			<path
				d='M1278,1517.78l1.74-13.1c.31-2.31.85-5.87,1.31-8.21h-.11c-1.12,2.45-2.47,5.33-3.8,7.82l-7.21,13.34h-2.28l-1.79-13.07c-.37-2.79-.62-5.6-.78-8.09h-.08c-.51,2.24-1.27,5.91-1.85,8.22l-3.3,13.09h-2.81l6.28-24.26h3.81l1.92,13.91c.24,2.06.52,4.28.58,6.08h.11c.74-1.8,1.78-3.98,2.82-6l7.51-14h3.9l-3.08,24.26h-2.91Z'
				className='shape'
			/>
			<path
				d='M1305.24,1507.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1291.86,1510.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1310.21,1517.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1340.11,1495.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M1346.43,1521.73c1.06.67,2.79,1.14,4.62,1.14,2.93,0,5.23-1.49,6.26-6.2l.58-2.6h-.09c-1.52,2.49-3.65,3.7-6.05,3.7-3.5,0-5.3-2.94-5.3-6.03-.01-5.93,4.31-11.76,11.05-11.76,2.02,0,4.22.56,5.59,1.21l-2.67,14.39c-.7,3.69-1.7,6.23-3.51,7.79-1.74,1.51-4.09,1.93-6.08,1.93-2.12,0-4.13-.49-5.22-1.23l.83-2.34ZM1359.81,1502.96c-.55-.27-1.63-.59-2.88-.59-4.36,0-7.36,4.56-7.38,8.85-.01,1.93.68,4.17,3.34,4.17s5.16-3.24,5.81-6.63l1.11-5.8Z'
				className='shape'
			/>
			<path
				d='M1384.73,1507.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1371.34,1510.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M1389.7,1517.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.78-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.81-.11,1.98-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.5-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.15-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M1434.22,1516.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1430.92,1502.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1440.85,1517.78l2.13-11.21c.43-2.27.69-4.58.88-6.19h2.63c-.14,1.21-.28,2.43-.48,3.78h.1c1.14-2.38,3-4.18,5.34-4.18.28,0,.62.02.85.06l-.58,2.95c-.21-.04-.47-.06-.81-.06-2.58,0-4.89,3.13-5.64,7.18l-1.44,7.68h-2.98Z'
				className='shape'
			/>
			<path
				d='M1459.7,1500.37l1.72,9.36c.39,2,.61,3.29.79,4.59h.09c.46-1.12.97-2.34,1.85-4.26l4.46-9.69h3.17l-6.54,13.23c-1.87,3.77-3.63,6.83-6,9.16-1.95,1.96-4.07,2.79-5.06,3.01l-.73-2.56c.75-.26,2.01-.75,3.19-1.68,1.18-.91,2.43-2.31,3.37-4.02.15-.29.14-.49.09-.79l-3.49-16.35h3.1Z'
				className='shape'
			/>
			<polygon
				points='1249.8 1455.08 1250.17 1470 1265.86 1470 1250.4 1479.22 1250.77 1494.15 1240.85 1484.92 1225.38 1494.15 1234.71 1479.22 1224.79 1470 1240.48 1470 1249.8 1455.08'
				className='shape'
			/>
			<rect x='1589.56' y='1759' width='262.94' height='38' fill='none' className='shape' />
			<path
				d='M1598.99,1769.11h-7.09l.51-2.59h17.18l-.5,2.59h-7.12l-4.11,21.67h-2.98l4.11-21.67Z'
				className='shape'
			/>
			<path
				d='M1619.33,1790.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1621.27,1775.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path d='M1629.47,1790.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path d='M1640.59,1790.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M1663.25,1790.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1665.19,1775.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1673.38,1790.78l4.86-25.56h2.98l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<path
				d='M1707.02,1790.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1708.96,1775.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1717.37,1787.76c.82.49,2.31,1.09,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.61,0,1.28.84,2.06,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1733.68,1787.76c.82.49,2.31,1.09,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.61,0,1.28.84,2.06,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1762.39,1789.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1759.09,1775.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M1781.62,1789.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1778.32,1775.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='1570.8 1726.08 1571.17 1741 1586.86 1741 1571.4 1750.22 1571.77 1765.15 1561.85 1755.92 1546.38 1765.15 1555.71 1750.22 1545.79 1741 1561.48 1741 1570.8 1726.08'
				className='shape'
			/>
			<rect x='1499.68' y='1239' width='172.82' height='38' fill='none' className='shape' />
			<path
				d='M1505.72,1263.1l-3.86,7.67h-3.14l12.53-24.26h3.53l3.35,24.26h-3.06l-.98-7.67h-8.37ZM1513.87,1260.73l-.94-7.01c-.13-1.26-.31-3.04-.43-4.46h-.08c-.65,1.45-1.25,2.96-1.99,4.42l-3.62,7.05h7.06Z'
				className='shape'
			/>
			<path
				d='M1531.68,1248.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path d='M1538.04,1270.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M1560.7,1270.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1562.63,1255.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1570.9,1270.78l2.33-12.34c.39-1.94.62-3.62.82-5.07h2.68l-.45,3.42h.07c1.57-2.45,3.91-3.82,6.46-3.82,2.07,0,4.4,1.19,4.4,4.83,0,.78-.14,1.88-.31,2.81l-1.93,10.16h-2.98l1.9-10.06c.12-.68.24-1.49.24-2.23,0-1.75-.67-3.03-2.73-3.03s-5.16,2.55-5.95,6.86l-1.57,8.46h-2.98Z'
				className='shape'
			/>
			<path
				d='M1600.79,1248.69l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M1618.66,1270.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1620.59,1255.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<polygon
				points='1491.92 1206.08 1492.29 1221 1507.99 1221 1492.52 1230.22 1492.89 1245.15 1482.97 1235.92 1467.5 1245.15 1476.83 1230.22 1466.91 1221 1482.6 1221 1491.92 1206.08'
				className='shape'
			/>
			<rect x='1702.5' y='1061' width='216' height='38' fill='none' className='shape' />
			<path
				d='M1775.51,1092c-1.37.61-3.57,1.16-6.3,1.16-6.11,0-9.85-3.88-9.85-10.07,0-4.57,1.85-8.92,5.18-11.69,2.51-2.12,5.6-3.25,9.14-3.25,2.7,0,4.64.67,5.26,1.17l-.96,2.41c-.9-.54-2.61-1-4.77-1-2.54,0-5.08.98-6.95,2.72-2.28,2.13-3.72,5.55-3.72,9.24,0,4.33,1.99,7.92,7.38,7.92,1.83,0,3.84-.37,5.18-1.04l.4,2.44Z'
				className='shape'
			/>
			<path
				d='M1797.95,1082.22c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM1784.57,1085.91c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path d='M1802.93,1092.78l4.87-25.56h2.99l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M1831.02,1075.37l-2.35,12.34c-.37,1.94-.61,3.62-.78,5.07h-2.69l.45-3.29h-.07c-1.55,2.27-3.84,3.68-6.14,3.68s-4.6-1.08-4.6-5.04c0-.84.11-1.78.33-2.93l1.88-9.83h2.98l-1.85,9.7c-.19.97-.3,1.8-.3,2.55,0,1.8.74,3.03,2.78,3.03,2.18,0,4.95-2.54,5.67-6.36l1.7-8.93h2.98Z'
				className='shape'
			/>
			<path
				d='M1835.86,1092.78l2.31-12.34c.38-1.94.62-3.62.81-5.07h2.63l-.46,3.27h.08c1.63-2.43,3.82-3.66,6.13-3.66,2.65,0,3.94,1.68,4.07,3.88,1.56-2.52,3.77-3.84,6.4-3.88,2.02,0,4.23,1.29,4.23,4.57,0,.81-.11,1.98-.29,2.96l-1.94,10.28h-2.92l1.88-10.03c.13-.67.25-1.55.25-2.27,0-1.84-.7-3.02-2.62-3.02-2.18,0-4.75,2.5-5.47,6.4l-1.66,8.92h-2.91l1.94-10.22c.14-.78.23-1.45.23-2.13,0-1.47-.41-2.98-2.61-2.98s-4.89,2.88-5.56,6.57l-1.61,8.75h-2.92Z'
				className='shape'
			/>
			<path
				d='M1875.5,1067.22l-2.3,11.3.07.02c1.55-2.34,3.78-3.56,6.12-3.56,3.82,0,5.27,3.15,5.27,6.24,0,5.36-3.87,11.96-10.85,11.96-3.07,0-5.37-1.28-5.36-4.49,0-.85.14-1.87.3-2.7l3.75-18.76h2.99ZM1871.72,1086.05c-.12.59-.23,1.28-.21,2.21.02,1.66.96,2.57,2.82,2.57,4.51,0,7.23-5.35,7.23-9.22,0-2.16-.94-4.15-3.32-4.15-2.57,0-5.25,2.67-6.12,6.74l-.39,1.85Z'
				className='shape'
			/>
			<path
				d='M1889.61,1092.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1893.48,1070.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M1912.27,1092.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1914.21,1077.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<polygon
				points='1923.92 1103.08 1924.29 1118 1939.99 1118 1924.52 1127.22 1924.89 1142.15 1914.97 1132.92 1899.5 1142.15 1908.83 1127.22 1898.91 1118 1914.6 1118 1923.92 1103.08'
				className='shape'
			/>
			<rect x='1133.68' y='825' width='209.82' height='44' fill='none' className='shape' />
			<path
				d='M1134.8,859.78l4.61-24.26h3.27l5.56,13.74c1.07,2.76,1.62,4.68,2.13,6.77l.08-.04c.13-2.18.39-4.19,1.02-7.59l2.45-12.87h2.82l-4.61,24.26h-2.95l-5.53-13.71c-1.18-3-1.72-4.7-2.25-7l-.11.04c-.27,2.27-.65,4.69-1.27,7.99l-2.4,12.68h-2.81Z'
				className='shape'
			/>
			<path
				d='M1171.87,859.78c-.01-1.05.16-2.69.39-4.5h-.08c-1.88,3.62-4.28,4.89-6.74,4.89-3.08,0-5.01-2.45-5.01-5.75,0-6.06,4.46-12.45,12.04-12.45,1.67,0,3.49.29,4.7.66l-1.78,9.07c-.58,3.03-.82,6.14-.74,8.07h-2.78ZM1173.81,844.6c-.42-.14-1.06-.25-2.07-.25-4.51,0-8.19,4.69-8.21,9.53-.01,1.95.67,3.84,2.97,3.84,2.5,0,5.42-3.25,6.29-7.87l1.01-5.25Z'
				className='shape'
			/>
			<path
				d='M1182.22,856.76c.82.49,2.31,1.09,3.74,1.08,2.01,0,3.31-1.3,3.31-2.84,0-1.36-.61-2.21-2.42-3.21-2.02-1.11-3.15-2.65-3.15-4.44,0-3.04,2.64-5.37,6.31-5.37,1.58,0,2.97.42,3.62.86l-.84,2.25c-.6-.35-1.7-.79-3-.79-1.82,0-3.1,1.13-3.1,2.61,0,1.28.84,2.06,2.39,2.93,1.94,1.1,3.25,2.62,3.25,4.57,0,3.66-2.98,5.74-6.65,5.74-1.87,0-3.54-.59-4.33-1.19l.85-2.21Z'
				className='shape'
			/>
			<path
				d='M1198.38,859.78l4.86-25.56h2.98l-2.17,11.22h.07c1.49-2.12,3.59-3.46,6.22-3.46,1.98,0,4.33,1.19,4.33,4.66,0,.93-.12,2.06-.29,2.95l-1.94,10.19h-2.98l1.91-10.06c.12-.64.23-1.44.23-2.4,0-1.6-.77-2.86-2.7-2.86-2.31,0-5.2,2.7-5.93,6.6l-1.62,8.72h-2.98Z'
				className='shape'
			/>
			<path
				d='M1224.14,842.37l1.5,9.91c.26,1.98.49,3.32.56,4.28h.1c.38-.92.85-2.07,1.86-4.06l5.31-10.13h3.27l-9.69,17.41h-2.94l-3.01-17.41h3.04Z'
				className='shape'
			/>
			<path
				d='M1239.53,859.78l3.33-17.41h2.98l-3.33,17.41h-2.98ZM1243.41,837.51c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path d='M1250.66,859.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path d='M1261.79,859.78l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M1285.46,858.78c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM1282.15,844.3c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<polygon
				points='1120.92 858.08 1121.29 873 1136.99 873 1121.52 882.22 1121.89 897.15 1111.97 887.92 1096.5 897.15 1105.83 882.22 1095.91 873 1111.6 873 1120.92 858.08'
				className='shape'
			/>
			<rect x='421.5' y='1152' width='236' height='45' fill='none' className='shape' />
			<path
				d='M427.24,1163.02h2.99l-4.14,21.67h9.79l-.5,2.59h-12.75l4.61-24.26Z'
				className='shape'
			/>
			<path
				d='M441.31,1187.28l3.33-17.41h2.98l-3.33,17.41h-2.98ZM445.19,1165.01c.01-1.15.88-2.02,1.96-2.02s1.78.78,1.78,1.87c-.04,1.18-.87,2.01-2.02,2.01-1.05,0-1.74-.8-1.72-1.86Z'
				className='shape'
			/>
			<path
				d='M460.23,1165.19l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path
				d='M474.38,1165.19l-.9,4.68h4.16l-.47,2.34h-4.16l-1.6,8.46c-.19.97-.35,1.87-.35,2.78,0,1.04.49,1.69,1.65,1.69.54,0,1.02-.04,1.41-.14l-.14,2.35c-.53.2-1.44.32-2.31.32-2.63,0-3.66-1.6-3.66-3.38,0-1.01.13-2.01.38-3.27l1.7-8.81h-2.49l.45-2.34h2.5l.73-3.92,3.1-.75Z'
				className='shape'
			/>
			<path d='M480.74,1187.28l4.87-25.56h2.98l-4.88,25.56h-2.98Z' className='shape' />
			<path
				d='M504.41,1186.28c-1.32.74-3.42,1.38-5.76,1.38-4.62,0-6.62-3.15-6.62-7,0-5.24,3.89-11.18,9.5-11.18,3.31,0,5.11,1.97,5.11,4.47,0,4.57-5.15,5.78-11.59,5.65-.15.75-.04,2.38.35,3.31.7,1.57,2.08,2.34,3.87,2.34,2.07,0,3.62-.62,4.69-1.19l.44,2.23ZM501.11,1171.8c-2.84,0-4.99,2.78-5.72,5.5,4.69.06,8.36-.57,8.36-3.28,0-1.43-1.09-2.22-2.65-2.22Z'
				className='shape'
			/>
			<path
				d='M525.13,1163.38c1.48-.33,3.49-.52,5.29-.52,2.42,0,4.5.57,5.8,1.76,1.12.97,1.79,2.36,1.79,4.02,0,3.52-2.7,6.16-5.76,7.01v.09c1.69.56,2.49,2.38,2.67,4.87.27,3.38.44,5.7.76,6.67h-3.09c-.14-.51-.39-3.05-.56-5.85-.19-3.34-1.42-4.72-3.82-4.72h-2.65l-2,10.57h-2.96l4.55-23.9ZM526,1174.39h2.67c3.78,0,6.22-2.47,6.22-5.38,0-2.6-1.96-3.76-4.69-3.76-1.19,0-1.96.1-2.51.26l-1.69,8.88Z'
				className='shape'
			/>
			<path
				d='M558.82,1176.72c0,5.38-3.82,10.96-9.67,10.96-4.36,0-6.8-3.23-6.8-7.15,0-5.75,3.99-11.05,9.66-11.05,4.69,0,6.81,3.55,6.81,7.24ZM545.43,1180.41c0,2.83,1.57,4.9,4.13,4.9,3.51,0,6.18-4.55,6.18-8.6,0-2.03-.94-4.87-4.06-4.87-3.76,0-6.25,4.58-6.25,8.57Z'
				className='shape'
			/>
			<path
				d='M575.87,1186.59c-.89.44-2.69,1.07-5.06,1.07-4.48,0-6.7-3.04-6.7-6.73,0-5.94,4.42-11.44,10.68-11.44,1.62,0,3.09.47,3.62.79l-.85,2.37c-.69-.33-1.65-.66-2.96-.66-4.52,0-7.38,4.46-7.38,8.56,0,2.83,1.48,4.66,4.34,4.66,1.77,0,3.13-.54,4.02-.97l.29,2.36Z'
				className='shape'
			/>
			<path
				d='M582,1187.28l4.86-25.56h2.97l-3.06,16.02h.07c.53-.61,1.17-1.27,1.63-1.75l6.13-6.12h3.69l-7.6,7.15,5.2,10.26h-3.29l-4.19-8.59-2.2,1.97-1.25,6.63h-2.96Z'
				className='shape'
			/>
			<polygon
				points='416.92 1130.08 417.29 1145 432.99 1145 417.52 1154.22 417.89 1169.15 407.97 1159.92 392.5 1169.15 401.83 1154.22 391.91 1145 407.6 1145 416.92 1130.08'
				className='shape'
			/>
			<rect
				x='248.83'
				y='1015.99'
				width='309.67'
				height='55.48'
				fill='none'
				className='shape'
			/>
			<path
				d='M258.9,1052.23l-6.43,12.79h-5.24l20.89-40.44h5.88l5.59,40.44h-5.1l-1.63-12.79h-13.96ZM272.48,1048.27l-1.57-11.68c-.22-2.11-.52-5.07-.72-7.44h-.14c-1.08,2.41-2.08,4.93-3.31,7.37l-6.03,11.76h11.77Z'
				className='shape'
			/>
			<path
				d='M289.83,1065.03l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M313.66,1065.03l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<path
				d='M364.21,1065.03c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM367.44,1039.72c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M381.21,1065.03l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M418.29,1059.99c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M464.47,1065.03c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM467.7,1039.72c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M481.71,1059.99c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.42,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<rect
				x='255.11'
				y='1590.72'
				width='335.39'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M264.67,1598.22h4.98l-6.89,36.11h16.31l-.83,4.33h-21.25l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M314.41,1621.05c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.92,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM292.1,1627.21c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M350.99,1609.65l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M359.05,1638.66l5.54-29.02h4.96l-5.54,29.02h-4.97ZM365.51,1601.54c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M377.83,1633.62c1.37.82,3.85,1.81,6.24,1.81,3.35,0,5.52-2.17,5.52-4.74,0-2.26-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M404.77,1638.66l5.54-29.02h4.96l-5.54,29.02h-4.97ZM411.23,1601.54c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M442.55,1638.66c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM445.77,1613.36c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.82-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M459.54,1638.66l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M515.62,1638.66c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM518.85,1613.36c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.82-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect
				x='586.84'
				y='1342.81'
				width='382.66'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M622.59,1390.75l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M640.5,1390.75l5.54-29.02h4.96l-5.54,29.02h-4.97ZM646.97,1353.63c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M659.29,1385.71c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M686.46,1385.71c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M713.4,1390.75l5.54-29.02h4.96l-5.54,29.02h-4.97ZM719.86,1353.63c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M732.18,1385.71c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M759.36,1385.71c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M786.3,1390.75l5.54-29.02h4.96l-5.54,29.02h-4.97ZM792.76,1353.63c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M802.22,1402.63l5.81-30.61c.66-3.49,1.25-7.36,1.63-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM810.39,1385.88c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M838.52,1402.63l5.81-30.61c.66-3.49,1.25-7.36,1.63-10.28h4.55l-.81,5.46h.12c2.64-3.83,6.46-6.12,10.44-6.12,6.29,0,8.94,5.16,8.94,10.48,0,10.22-7.33,19.85-17,19.85-3.08,0-5.13-.68-6.25-1.3h-.12l-2.34,12.52h-4.96ZM846.69,1385.88c1.28,1,3.16,1.6,5.54,1.6,6.42,0,11.79-7.97,11.79-15.56,0-3.04-1.34-6.71-5.56-6.71-3.92,0-8.78,4.46-10.29,12.57l-1.47,8.1Z'
				className='shape'
			/>
			<path
				d='M877.44,1390.75l5.54-29.02h4.96l-5.54,29.02h-4.97ZM883.9,1353.63c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<rect
				x='1015.8'
				y='1569.81'
				width='308.7'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1025.87,1604.96l-6.43,12.79h-5.24l20.89-40.44h5.88l5.59,40.44h-5.1l-1.63-12.79h-13.96ZM1039.46,1601l-1.57-11.68c-.22-2.11-.52-5.07-.72-7.44h-.14c-1.08,2.41-2.08,4.93-3.31,7.37l-6.03,11.76h11.77Z'
				className='shape'
			/>
			<path d='M1056.45,1617.75l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M1094.22,1617.75c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1097.45,1592.45c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1123.89,1575.15l-3.83,18.83.12.03c2.58-3.91,6.3-5.94,10.21-5.94,6.36,0,8.79,5.25,8.79,10.39,0,8.93-6.45,19.94-18.08,19.94-5.11,0-8.95-2.13-8.94-7.49,0-1.42.24-3.12.51-4.51l6.25-31.27h4.98ZM1117.6,1606.53c-.2.99-.38,2.14-.36,3.68.03,2.76,1.61,4.28,4.7,4.28,7.52,0,12.06-8.92,12.06-15.37,0-3.6-1.57-6.92-5.54-6.92-4.28,0-8.75,4.45-10.21,11.24l-.65,3.09Z'
				className='shape'
			/>
			<path
				d='M1166.64,1617.75c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1169.87,1592.45c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M1183.64,1617.75l3.85-20.57c.63-3.23,1.03-6.04,1.34-8.45h4.39l-.77,5.44h.14c2.72-4.05,6.37-6.1,10.22-6.1,4.42,0,6.57,2.8,6.78,6.47,2.6-4.2,6.29-6.41,10.66-6.47,3.36,0,7.05,2.14,7.05,7.61,0,1.34-.18,3.29-.48,4.93l-3.24,17.13h-4.86l3.13-16.71c.21-1.12.42-2.59.42-3.79,0-3.07-1.16-5.04-4.37-5.04-3.63,0-7.92,4.18-9.12,10.67l-2.77,14.87h-4.84l3.24-17.03c.24-1.3.39-2.41.39-3.54,0-2.44-.68-4.97-4.35-4.97s-8.15,4.8-9.27,10.96l-2.68,14.59h-4.86Z'
				className='shape'
			/>
			<path
				d='M1256.16,1617.75c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1259.39,1592.45c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect
				x='1861.8'
				y='2042.81'
				width='244.7'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1871.36,2050.31h20.53l-.83,4.25h-15.52l-2.61,13.64h14.3l-.83,4.23h-14.3l-3.46,18.32h-4.97l7.69-40.44Z'
				className='shape'
			/>
			<path d='M1895.26,2090.75l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M1941.63,2073.14c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1919.31,2079.3c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M1949.9,2090.75l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M1973.72,2090.75l5.54-29.02h4.96l-5.54,29.02h-4.97ZM1980.18,2053.63c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M2023.12,2048.15l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM2014.77,2066.28c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<path
				d='M2047.8,2090.75c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2051.03,2065.45c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect
				x='1480.8'
				y='1404.81'
				width='269.7'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1512.43,1451.02c-2.35.93-6.64,2.14-11.4,2.14-5.7,0-10.16-1.62-13.22-5.04-3.06-3.38-4.07-7.8-4.07-11.8,0-6.71,2.72-13.74,7.9-18.4,4.33-3.81,10.14-6.01,16.62-6.01,4.98,0,8.33,1.13,9.56,1.85l-1.64,4.2c-2.05-1.05-4.85-1.76-8.5-1.76-4.76,0-9.15,1.77-12.52,4.92-3.78,3.52-6.06,9.32-6.06,14.8,0,7.8,3.93,12.98,12.91,12.98,2.39,0,4.67-.49,6.15-1.14l2.29-12.08h-8.19l.78-4.08h13.07l-3.66,19.41Z'
				className='shape'
			/>
			<path
				d='M1545.79,1451.09c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1540.28,1426.95c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1584.74,1435.14c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1562.43,1441.3c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M1593.02,1452.75l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M1616.67,1459.34c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.03.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM1638.97,1428.05c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M1652.6,1452.75l5.54-29.02h4.96l-5.54,29.02h-4.97ZM1659.06,1415.63c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1690.38,1452.75c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1693.61,1427.45c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect x='999.8' y='929.81' width='340.7' height='53.28' fill='none' className='shape' />
			<path
				d='M1015.52,941.64h-11.81l.85-4.33h28.64l-.84,4.33h-11.88l-6.84,36.11h-4.96l6.84-36.11Z'
				className='shape'
			/>
			<path
				d='M1052.13,976.09c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1046.63,951.95c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1063.18,977.75l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M1100.02,977.75l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M1157.79,976.09c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1152.29,951.95c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1169.08,972.71c1.37.82,3.85,1.81,6.24,1.81,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1196.26,972.71c1.37.82,3.85,1.81,6.24,1.81,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.03,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1244.12,976.09c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1238.62,951.95c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1276.16,976.09c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1270.66,951.95c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<rect
				x='1051.8'
				y='630.81'
				width='305.7'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1061.36,638.31h4.93l-3.74,19.67.25-.03c1.39-1.73,2.76-3.15,3.99-4.54l14.23-15.1h6.23l-17.01,17.39,10.38,23.04h-5.41l-8.86-19.86-4.82,4.5-2.95,15.36h-4.92l7.69-40.44Z'
				className='shape'
			/>
			<path
				d='M1109.65,677.09c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1104.15,652.95c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1120.7,678.75l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.11h-4.97Z'
				className='shape'
			/>
			<path
				d='M1170.53,641.94l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M1209.42,649.74l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.45h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M1237.44,677.6c-1.48.73-4.49,1.78-8.43,1.78-7.46,0-11.16-5.06-11.16-11.22,0-9.9,7.37-19.07,17.8-19.07,2.7,0,5.15.79,6.03,1.32l-1.42,3.95c-1.15-.55-2.74-1.09-4.93-1.09-7.53,0-12.3,7.43-12.3,14.27,0,4.72,2.47,7.76,7.23,7.76,2.95,0,5.22-.91,6.7-1.62l.48,3.93Z'
				className='shape'
			/>
			<path
				d='M1247.67,678.75l8.1-42.6h4.95l-5.1,26.71h.12c.88-1.02,1.95-2.12,2.71-2.92l10.23-10.2h6.15l-12.66,11.91,8.66,17.1h-5.48l-6.99-14.32-3.67,3.28-2.08,11.05h-4.94Z'
				className='shape'
			/>
			<path
				d='M1286.63,649.74l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.89,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<rect
				x='1938.8'
				y='1126.81'
				width='295.7'
				height='152.19'
				fill='none'
				className='shape'
			/>
			<path
				d='M1941.29,1181.95c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<path
				d='M2001.71,1170.6c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1979.39,1176.76c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M2038.28,1159.19l-3.91,20.57c-.61,3.23-1.02,6.04-1.3,8.44h-4.49l.75-5.48h-.12c-2.59,3.78-6.4,6.14-10.24,6.14s-7.66-1.8-7.66-8.4c0-1.4.18-2.96.56-4.88l3.14-16.39h4.96l-3.08,16.17c-.31,1.61-.49,3.01-.49,4.25,0,3,1.23,5.05,4.64,5.05,3.63,0,8.25-4.23,9.45-10.6l2.83-14.88h4.96Z'
				className='shape'
			/>
			<path
				d='M2059.33,1151.39l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M2069.92,1188.21l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.97l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M1968.62,1258.9c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M1997.36,1260.21c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2000.59,1234.9c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2014.36,1260.21l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M2065.73,1242.6c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM2043.41,1248.76c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path d='M2074.01,1260.21l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M2092.54,1260.21l5.54-29.02h4.96l-5.54,29.02h-4.97ZM2099,1223.09c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M2111.08,1260.21l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M2167.16,1260.21c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2170.39,1234.9c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect
				x='1747.88'
				y='842.39'
				width='505.62'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1749.75,890.33l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<path
				d='M1820.14,872.73c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.65-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM1797.83,878.88c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.56-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path
				d='M1828.42,890.33l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.96Z'
				className='shape'
			/>
			<path
				d='M1866.84,853.52l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.7-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M1877.44,890.33l8.1-42.6h4.98l-3.62,18.7h.12c2.49-3.53,5.99-5.77,10.37-5.77,3.29,0,7.22,1.99,7.22,7.77,0,1.55-.19,3.44-.48,4.91l-3.23,16.99h-4.96l3.18-16.77c.2-1.06.39-2.4.39-4,0-2.67-1.28-4.76-4.51-4.76-3.85,0-8.67,4.5-9.88,11l-2.71,14.54h-4.97Z'
				className='shape'
			/>
			<path
				d='M1958.12,889.03c-2.28,1.02-5.95,1.94-10.49,1.94-10.18,0-16.41-6.47-16.41-16.79,0-7.61,3.08-14.87,8.63-19.49,4.18-3.53,9.33-5.42,15.24-5.42,4.5,0,7.73,1.12,8.76,1.94l-1.6,4.01c-1.5-.91-4.35-1.66-7.95-1.66-4.23,0-8.47,1.64-11.58,4.53-3.8,3.56-6.2,9.26-6.2,15.39,0,7.23,3.32,13.2,12.3,13.2,3.05,0,6.39-.61,8.64-1.73l.66,4.07Z'
				className='shape'
			/>
			<path
				d='M1986.85,890.33c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1990.08,865.03c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2003.85,890.33l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.3,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M2055.22,872.73c0,8.96-6.36,18.27-16.12,18.27-7.27,0-11.33-5.39-11.33-11.91,0-9.59,6.66-18.42,16.09-18.42,7.83,0,11.36,5.92,11.36,12.07ZM2032.9,878.88c0,4.71,2.62,8.17,6.88,8.17,5.85,0,10.3-7.59,10.3-14.34,0-3.39-1.57-8.11-6.76-8.11-6.27,0-10.42,7.63-10.42,14.28Z'
				className='shape'
			/>
			<path d='M2063.51,890.33l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M2082.03,890.33l5.54-29.02h4.96l-5.54,29.02h-4.96ZM2088.49,853.22c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.38,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M2100.57,890.33l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.45,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.96Z'
				className='shape'
			/>
			<path
				d='M2156.65,890.33c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2159.88,865.03c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect
				x='1920.88'
				y='568.39'
				width='276.62'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M1930.88,616.33l-4.99-40.44h5.08l2.94,25.89c.46,4.18.72,6.48.77,9.16h.17c1.02-2.51,2.25-5.53,4.44-9.77l12.88-25.28h5.48l-21.27,40.44h-5.5Z'
				className='shape'
			/>
			<path
				d='M1959.24,616.33l5.54-29.02h4.96l-5.54,29.02h-4.96ZM1965.7,579.22c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1977.78,616.33l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.3,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M2001.43,622.93c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.04.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM2023.73,591.63c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M2037.36,616.33l5.54-29.02h4.96l-5.54,29.02h-4.97ZM2043.82,579.22c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.38,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M2055.9,616.33l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M2092.74,616.33l5.54-29.02h4.96l-5.54,29.02h-4.97ZM2099.2,579.22c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.38,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M2130.52,616.33c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2133.74,591.03c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect
				x='1687.22'
				y='195.94'
				width='295.7'
				height='152.19'
				fill='none'
				className='shape'
			/>
			<path
				d='M1695.04,257.33l-1.98-40.44h5l.86,24.24c.15,5.23.05,7.99,0,10.53h.14c.94-2.64,1.93-5.26,4.16-10.25l11.2-24.53h5.33l.83,23.28c.19,5.24.18,8.75.09,11.42h.13c1.19-3.48,2.4-6.72,3.95-10.41l10.89-24.28h5.22l-18.76,40.44h-5.27l-1.03-23c-.22-4.7-.17-7,.09-11.63h-.15c-1.35,3.88-2.42,6.97-4.09,10.64l-11.28,24h-5.34Z'
				className='shape'
			/>
			<path
				d='M1762.58,255.67c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM1757.08,231.53c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path
				d='M1773.88,252.29c1.37.82,3.85,1.81,6.24,1.8,3.35,0,5.52-2.16,5.52-4.74,0-2.27-1.02-3.68-4.03-5.35-3.36-1.86-5.25-4.42-5.25-7.4,0-5.07,4.4-8.95,10.52-8.95,2.63,0,4.95.71,6.04,1.44l-1.4,3.76c-1-.58-2.83-1.32-5-1.32-3.04,0-5.18,1.89-5.18,4.36,0,2.14,1.39,3.43,3.99,4.89,3.23,1.83,5.42,4.36,5.42,7.62,0,6.1-4.96,9.56-11.08,9.56-3.12,0-5.9-.98-7.22-1.99l1.42-3.68Z'
				className='shape'
			/>
			<path
				d='M1813.8,220.52l-1.49,7.8h6.93l-.78,3.9h-6.94l-2.67,14.11c-.31,1.62-.58,3.12-.58,4.63,0,1.73.82,2.81,2.75,2.81.89,0,1.69-.06,2.34-.23l-.24,3.92c-.88.34-2.4.53-3.85.53-4.39,0-6.11-2.66-6.11-5.63,0-1.69.21-3.34.64-5.44l2.83-14.69h-4.15l.75-3.9h4.17l1.22-6.54,5.17-1.26Z'
				className='shape'
			/>
			<path
				d='M1697.22,329.33l-4.99-40.44h5.08l2.94,25.89c.46,4.18.72,6.48.77,9.16h.17c1.02-2.51,2.25-5.53,4.44-9.77l12.88-25.28h5.48l-21.27,40.44h-5.5Z'
				className='shape'
			/>
			<path
				d='M1725.58,329.33l5.54-29.02h4.96l-5.54,29.02h-4.96ZM1732.04,292.22c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.45,3.35-3.37,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1744.12,329.33l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.3,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M1767.77,335.93c1.76,1.12,4.65,1.9,7.7,1.9,4.88,0,8.71-2.48,10.43-10.33l.96-4.34h-.15c-2.54,4.15-6.08,6.17-10.09,6.17-5.83,0-8.83-4.91-8.84-10.05-.02-9.88,7.19-19.61,18.42-19.61,3.37,0,7.04.94,9.31,2.02l-4.45,23.98c-1.17,6.15-2.83,10.39-5.85,12.99-2.9,2.51-6.82,3.22-10.13,3.22-3.53,0-6.88-.82-8.7-2.05l1.39-3.9ZM1790.07,304.63c-.92-.46-2.72-.99-4.8-.99-7.26,0-12.26,7.59-12.29,14.76-.02,3.22,1.14,6.96,5.56,6.96s8.61-5.39,9.68-11.06l1.85-9.67Z'
				className='shape'
			/>
			<path
				d='M1803.7,329.33l5.54-29.02h4.96l-5.54,29.02h-4.97ZM1810.16,292.22c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.38,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1822.24,329.33l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.96l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M1859.08,329.33l5.54-29.02h4.96l-5.54,29.02h-4.97ZM1865.54,292.22c.02-1.92,1.47-3.37,3.27-3.37s2.96,1.31,2.96,3.12c-.06,1.96-1.46,3.35-3.38,3.35-1.75,0-2.89-1.34-2.86-3.11Z'
				className='shape'
			/>
			<path
				d='M1896.85,329.33c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM1900.08,304.03c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<rect
				x='2090.25'
				y='107.92'
				width='328.25'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M2125.99,155.86l2.9-21.84c.53-3.86,1.42-9.78,2.19-13.68h-.19c-1.87,4.08-4.12,8.89-6.33,13.03l-12.01,22.24h-3.8l-2.99-21.78c-.62-4.64-1.03-9.34-1.3-13.48h-.13c-.85,3.74-2.12,9.84-3.08,13.69l-5.5,21.83h-4.68l10.47-40.44h6.35l3.2,23.19c.4,3.44.87,7.13.97,10.14h.18c1.23-3.01,2.96-6.63,4.71-10l12.52-23.33h6.51l-5.13,40.44h-4.84Z'
				className='shape'
			/>
			<path
				d='M2162.79,155.86c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2166.02,130.56c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2179.79,155.86l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M2211.21,126.85l2.87,15.61c.64,3.34,1.02,5.48,1.31,7.65h.15c.76-1.86,1.62-3.9,3.08-7.11l7.43-16.15h5.28l-10.9,22.05c-3.11,6.29-6.05,11.38-10,15.27-3.24,3.27-6.79,4.65-8.44,5.01l-1.22-4.28c1.25-.44,3.35-1.25,5.32-2.79,1.96-1.51,4.06-3.85,5.61-6.7.25-.48.23-.81.15-1.32l-5.82-27.25h5.17Z'
				className='shape'
			/>
			<path d='M2236.14,155.86l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M2273.91,155.86c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2277.14,130.56c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2290.91,155.86l3.88-20.57c.64-3.23,1.04-6.04,1.37-8.45h4.47l-.75,5.7h.12c2.61-4.08,6.51-6.36,10.76-6.36,3.44,0,7.34,1.99,7.34,8.06,0,1.29-.23,3.13-.52,4.68l-3.22,16.94h-4.97l3.17-16.76c.2-1.13.39-2.48.39-3.71,0-2.91-1.12-5.06-4.55-5.06s-8.61,4.25-9.92,11.43l-2.62,14.1h-4.97Z'
				className='shape'
			/>
			<path
				d='M2358.61,113.26l-6.37,33.4c-.56,3.01-1.05,6.39-1.22,9.2h-4.56l.77-5.74h-.12c-2.65,4.11-6.3,6.4-10.47,6.4-5.6,0-8.67-4.6-8.67-10.56,0-10.32,7.67-19.77,17.95-19.77,1.82,0,3.87.39,5.12.99l2.6-13.92h4.95ZM2350.26,131.39c-1-.68-2.66-1.23-4.75-1.23-6.96,0-12.38,7.42-12.38,15.12,0,3.51,1.2,7.16,5.48,7.16,3.82,0,8.46-4.37,9.71-10.9l1.94-10.15Z'
				className='shape'
			/>
			<rect
				x='2461.25'
				y='72.92'
				width='322.25'
				height='53.28'
				fill='none'
				className='shape'
			/>
			<path
				d='M2470.71,80.96c3.11-.54,6.51-.81,10.05-.81,6.74,0,11.89,1.91,14.88,5.38,2.18,2.25,3.78,5.86,3.8,10.96,0,7.32-2.91,14.57-8.11,19.01-4.68,3.93-10.57,5.63-18.33,5.63-3.53,0-7.19-.2-9.81-.51l7.53-39.66ZM2468.91,116.72c1.81.24,3.72.29,5.22.29,6.43,0,11.1-1.89,14.47-5.37,3.64-3.71,5.51-9.23,5.51-14.92,0-7.15-3.5-12.51-13.58-12.51-1.81,0-4.07.11-5.51.42l-6.11,32.09Z'
				className='shape'
			/>
			<path
				d='M2528.16,119.2c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2522.65,95.06c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
			<path d='M2539.22,120.86l8.12-42.6h4.98l-8.13,42.6h-4.96Z' className='shape' />
			<path
				d='M2576.99,120.86c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2580.22,95.56c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2600.68,91.85l1.02,16.32c.22,3.59.2,5.45.14,7.81h.13c.69-1.89,1.74-4.38,3.19-7.28l8.63-16.84h4.33l1.83,16.53c.3,3.19.49,5.66.46,7.59h.15c.77-2.34,1.57-4.58,2.74-7.36l7.83-16.76h5.07l-14.34,29.02h-4.62l-1.92-15.76c-.29-2.69-.44-5.16-.42-7.72h-.12c-1.22,2.8-2.05,5-3.37,7.58l-8.32,15.91h-4.65l-2.68-29.02h4.91Z'
				className='shape'
			/>
			<path
				d='M2659.25,120.86c-.02-1.75.27-4.49.65-7.5h-.13c-3.13,6.03-7.14,8.16-11.24,8.16-5.14,0-8.34-4.08-8.34-9.59,0-10.11,7.44-20.75,20.06-20.75,2.78,0,5.82.48,7.83,1.1l-2.96,15.12c-.96,5.05-1.36,10.24-1.23,13.45h-4.64ZM2662.48,95.56c-.7-.22-1.77-.41-3.45-.41-7.51,0-13.65,7.81-13.68,15.89-.02,3.24,1.12,6.4,4.95,6.4,4.17,0,9.04-5.41,10.49-13.12l1.69-8.76Z'
				className='shape'
			/>
			<path
				d='M2676.25,120.86l3.55-18.69c.71-3.78,1.15-7.63,1.47-10.33h4.38c-.24,2.02-.47,4.05-.81,6.3h.17c1.9-3.98,5-6.96,8.89-6.96.46,0,1.04.04,1.42.11l-.97,4.91c-.35-.07-.79-.1-1.35-.1-4.31,0-8.14,5.22-9.4,11.96l-2.4,12.8h-4.97Z'
				className='shape'
			/>
			<path
				d='M2720.69,119.2c-2.19,1.23-5.7,2.29-9.59,2.29-7.71,0-11.04-5.25-11.04-11.68,0-8.74,6.49-18.63,15.83-18.63,5.52,0,8.52,3.29,8.52,7.44,0,7.62-8.59,9.63-19.31,9.42-.24,1.26-.07,3.96.59,5.52,1.17,2.62,3.47,3.9,6.46,3.9,3.45,0,6.04-1.03,7.82-1.99l.73,3.71ZM2715.19,95.06c-4.74,0-8.32,4.63-9.53,9.17,7.82.09,13.94-.95,13.94-5.47,0-2.39-1.82-3.7-4.41-3.7Z'
				className='shape'
			/>
		</svg>
	);
};

SoutheastMap.propTypes = {
	onStateClick: PropTypes.func.isRequired,
	selectedState: PropTypes.string,
};

export default SoutheastMap;
